<template>
  <div class="main-page">
    <div class="main-page_background-logo"></div>
    <div class="main-page_content-wrapper">
      <div class="main-page_content">
        <h1>HTML + CSS GAME COURSES</h1>
        <h4>Html and css learning while gaming! Enjoy!</h4>
        <router-link to="/login" class="btn btn-orange">Start now</router-link>
      </div>
    </div>
    <footer class="footer mt-auto py-3">
      <div class="col container">
        <router-link to="/imprint">Imprint</router-link>
        <router-link to="/privacy">Privacy</router-link>
        <span>&copy; 2019</span>
      </div>
    </footer>
  </div>
</template>

<script>
    export default {
        name: "Home"
    };
</script>



